const groupPrefix = createApiRoute(ApiModule.ORDER, ApiAuthorization.EMPLOYEE, ApiDataModel.DELIVERIES)
const groupImagePrefix = createApiRoute(ApiModule.LOGISTICS, ApiAuthorization.EMPLOYEE, ApiDataModel.PACKAGES)

export const apiOrderDeliveries = {
	fetchOrderDeliveryDates: async (clientID: number): Promise<{ dates: string[]; nearest: string | null }> => {
		const { data } = await apiCommon<{ dates: string[]; nearest: string | null }>(
			`${groupPrefix}/${clientID}/dates`,
			{ method: 'GET' },
		)

		return data
	},
	fetchOrderDeliveriesForClient: async (
		clientID: number,
		page: number = 1,
		perPage: number = 25,
		filters?: { date_from?: string; date_to?: string },
		sort: EApiSortType = EApiSortType.DESC,
		signal?: AbortSignal,
	): Promise<IApiResponseModel<IOrderDeliveryModel[]>> => {
		const { data, meta } = await apiCommon<IOrderDelivery[]>(`${groupPrefix}`, {
			method: 'GET',
			...createQuery({ page, perPage }, { client_id: clientID, ...filters }, { date: sort }),
			...(signal ? { signal } : {}),
		})

		return { data: data.map(OrderDelivery), meta }
	},
	fetchOrderDeliveryImage: async (packageGUID: string): Promise<IOrderDeliveryImage[]> => {
		const { data } = await apiCommon<any>(`${groupImagePrefix}/${packageGUID}/attachments`, {
			method: 'GET',
		})

		return data
	},
}
